import React from 'react';
import PropTypes from 'prop-types';

const ColorButton = ({ color, text, isSelected, onClick, size }) => {
  return (
    <div
      role="presentation"
      onClick={onClick}
      className={`color-button ${
        isSelected ? 'color-button-selected' : ''
      } ${size === 'small' && 'color-button_small'}`}
    >
      <div className="color-button_color" style={{ backgroundColor: color }} />
      <div className="color-button_text">{text}</div>
    </div>
  );
};

ColorButton.propTypes = {
  color: PropTypes.string,
  isSelected: PropTypes.bool,
  text: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func
};

ColorButton.defaultProps = {
  onClick: () => {}
};

export default ColorButton;
